import { RM01 } from "./RM01";
import { RM03 } from "./RM03";
import { RM04 } from "./RM04";
import { RM05 } from "./RM05";
import { RM06 } from "./RM06";

export const RegionCoverageReport = {
  sections: [
    RM06, 
    RM01, 
    RM05, 
    RM03, 
    RM04
  ],
};
